export enum SOCKET_DEVICE_EVENT {
  /**
   * Recieves an event when the device is added
   */
  added = 'device:added',
  /**
   * Recieves an event when the device is removed
   */
  removed = 'device:removed',
  /**
   * Recieves an event when the device is activated/deactivated
   */
  activated = 'device:activated',
  /**
   * Recieves an event when the device is unlinked
   */
  unlink = 'device:reset',
}
